export default function plusOrMinus (value) {
  if (value > 0) return `+${value}`
  else if (value < 0) return `${value}`

  return value
}
